<div class="nsw-header__inner" style="width:100%;">
    <div class="nsw-header__main">
        <div class="nsw-header__waratah">
            <a routerLink="home">
                <img class="gov-logo" src="assets/images/home/nsw-government-logo.svg" [alt]="NSWLogoAltText">
                <span class="sr-only">NSW Government</span>
            </a>
        </div>
        <div class="nsw-header__name">
            <div class="nsw-header__title">Beachwatch</div>
        </div>
    </div>
    <div class="nsw-header__menu">
        <button type="button" class="js-open-nav" aria-expanded="false" aria-controls="main-nav" (click)="onMobileMenuClicked()">
            <span class="material-icons nsw-material-icons" focusable="false" aria-hidden="true" alt="Open">menu</span>
            <span><span class="sr-only">Open</span> Menu</span>
        </button>
    </div>
    <div class="nsw-header__search" *ngIf="!searchOpen">
        <button type="button" class="js-open-search" aria-expanded="false" aria-controls="header-search"
            (click)="onSearchClicked()">
            <span class="material-icons nsw-material-icons" focusable="false" aria-hidden="true" alt="search">search</span>
            <span><span class="sr-only">Show</span> Search</span>
        </button>
    </div>
</div>

<div class="nsw-header__search-area js-search-area nsw-form__predictive" id="header-search" *ngIf="searchOpen">
    <form role="search" (keydown.enter)="onEnterPressed($event)">
        <label for="nsw-header-input" class="sr-only" for="global-search-input">Search site for:</label>
        <input type="text" class="nsw-header__input js-search-input" 
            id="global-search-input"
            [matAutocomplete]="searchAuto"
            [formControl]="searchFControl"
            #searchInput placeholder="Search" />
        <ul class="nsw-form__predictive-list">
            <mat-autocomplete autoActiveFirstOption 
                id="nsw-search__input-autocomplete-list" #searchAuto="matAutocomplete"
                (optionSelected)="navigateToPage($event.option.value)" [displayWith]="getDisplayName">
                <mat-option *ngFor="let option of dropdownValues" [value]="option"
                    >
                    <li><a  href="{{option.url}}"
                        [innerHTML]="highlight(option.display,searchFControl.value)" style="color:black;text-decoration: underline;font-weight:400;">{{ option.display }}</a></li>
                </mat-option>
            </mat-autocomplete>
        </ul>
        <button class="nsw-icon-button nsw-icon-button--flex" (click)="onSearchClicked()" aria-label="Search">
            <span class="material-icons nsw-material-icons" focusable="false" aria-hidden="true" alt="Search">search</span>
            <span class="sr-only">Search</span>
        </button>
    </form>
    <button class="nsw-icon-button js-close-search" aria-expanded="true" aria-controls="header-search" (click)="onSearchClicked()">
        <span class="material-icons nsw-material-icons" focusable="false" aria-hidden="true" alt="close">close</span>
        <span class="sr-only">Close search</span>
    </button>
</div>